import React from 'react';
import * as _ from 'lodash';
import { __, setTableParams, setURLParam, validateForm } from '../core/utils';
import styles from '../styles/wizards/CreateFolderWizard.scss';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import { attachModelsToFolders } from '../redux/actions/table/folders';
import { attachFilesToFolders, listFiles } from '../redux/actions/table/files';
import { listCurrentSetPlans } from '../redux/actions/table/current_set_plans';
import AttachFilesToFoldersForm from '../forms/attach_files_to_folders_wizard/AttachFilesToFoldersForm';
import FolderAddIcon from '../assets/images/folder-add-64x64.svg';
import FolderMoveIcon from '../assets/images/move-to-folder.svg';

const AttachFilesToFoldersWizard = ({
  match,
  onClose,
  plan_ids = [],
  file_ids = [],
  folders = [],
  singleAction = false,
  onAttached,
}) => {
  const isFilesWizard = !_.isEmpty(file_ids);

  const _handleSubmit = (formData) => {
    const folder_ids = formData.folder_ids || [];
    const removed_folder_ids = formData.removed_folder_ids || [];

    // if (!folder_ids.length && !removed_folder_ids.length) {
    //   return Promise.resolve();
    // }

    const request = isFilesWizard
      ? attachFilesToFolders(match.params.stage, {
          model_ids: file_ids,
          folder_ids,
          removed_folder_ids,
        })
      : attachModelsToFolders(match.params.stage, {
          module: 'plans',
          model_ids: plan_ids,
          folder_ids,
          removed_folder_ids,
        });

    return validateForm(
      request.then(() => {
        const shouldRedirectToFolder =
          singleAction && isFilesWizard && folder_ids.length;

        if (shouldRedirectToFolder) {
          setURLParam('filter.folder', _.first(folder_ids));
        }

        if (isFilesWizard && !shouldRedirectToFolder) {
          listFiles(match.params.stage);
        }

        if (!isFilesWizard) {
          listCurrentSetPlans(match.params.stage);
        }

        setTableParams(isFilesWizard ? 'files' : 'current_set_plans', {
          folders_reload_at: Date.now(),
          ...(shouldRedirectToFolder ? { selected_rows: [] } : {}),
        });
        setNotification(
          singleAction && isFilesWizard
            ? __('Files have been moved to selected folder.')
            : isFilesWizard
            ? __('Files have been added to selected folders.')
            : __('Plans have been added to selected folders.')
        );
        if (onAttached) {
          onAttached();
        }
        onClose();
      })
    );
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>
            {singleAction ? __('files.move-to-folder') : __('Add to folders')}
          </span>
          <span>
            {singleAction
              ? __('Select folder')
              : __('Select one or more folders')}
          </span>
        </div>
        <div
          className={
            singleAction
              ? `${styles.right} ${styles.moveToFolderIcon}`
              : styles.right
          }
        >
          {singleAction ? <FolderMoveIcon /> : <FolderAddIcon />}
        </div>
      </div>
      <div className={styles.body}>
        <AttachFilesToFoldersForm
          onSubmit={_handleSubmit}
          onClose={onClose}
          folders={folders}
          plan_ids={plan_ids}
          file_ids={file_ids}
          folder_model_key={isFilesWizard ? 'selected_count' : 'plan_ids'}
          singleAction={singleAction}
        />
      </div>
    </>
  );
};

export default withRouter(AttachFilesToFoldersWizard);
